<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :title="$t('personal::contract::开通套餐')"
      width="600px"
      :destroy-on-close="true"
      @closed="closed"
    >
      <div v-loading="getLoading">
        <div class="step-container">
          <z-step :active="active" :steps="steps"></z-step>
        </div>
        <!-- 绑卡流程 -->
        <div v-show="active === 1">
          <el-row :gutter="24" v-if="visible">
            <el-col :span="24" class="">
              <div class="card-title">
                <span>*</span>
                {{ $t('personal::contract::卡号') }}
              </div>
              <div id="card-number" class="input"></div>
              <div class="error-wrap" id="cardNumber-errors"></div>
            </el-col>
            <el-col :span="12">
              <div class="card-title">
                <span>*</span>
                {{ $t('personal::contract::到期日期') }}
              </div>
              <div id="card-date" class="input"></div>
              <div class="error-wrap" id="cardDate-errors"></div>
            </el-col>
            <el-col :span="12">
              <div class="card-title">
                <span>*</span>
                {{ $t('personal::contract::安全码') }}
              </div>
              <div id="card-cvc" class="input"></div>
              <div class="error-wrap" id="cardCvc-errors"></div>
            </el-col>
          </el-row>
          <div class="pay-tips">
            <el-checkbox v-model="isCheck">{{ $t('personal::contract::accept-tips') }}</el-checkbox>
            <a @click="toPdf">《{{ $t('personal::contract::服务协议') }}》</a>
            <p class="pay-tips__desc">
              {{ $t('personal::contract::pay-tips') }}
            </p>
          </div>
        </div>
        <!-- 填写优惠券流程 -->
        <div class="contract-info" v-show="active === 2">
          <div class="contract-title">{{ $t('personal::open-contract::comboInfo') }}</div>
          <z-table :data="[combo]" :columns="payColumns" :pagination="false" border></z-table>
          <template v-if="payCouponEnable">
            <div class="contract-title mt-16">{{ $t('personal::contract::useCoupon') }}</div>
            <el-input
              v-model="couponCode"
              :placeholder="$t('personal::contract::inputCouponCode')"
              @blur="checkCode"
              :class="[{ 'error-border': !!resultMsg }, { 'success-border': resultMsg === 1 }]"
            ></el-input>
          </template>
          <p class="error-tips" v-show="resultMsg">
            <span v-if="resultMsg === 1" style="color: #0560fd">{{ $t('personal::contract::couponCanUse') }}</span>
            <span v-else-if="resultMsg === 2">
              {{ $t('personal::contract::couponNotUse', { name: tempCombo.name }) }}
              <a @click="changeCombo">{{ $t('personal::contract::buyNow') }}</a>
            </span>
            <span v-else>{{ resultMsg }}</span>
          </p>
        </div>
        <!-- 选卡支付流程 -->
        <div v-show="active === 3">
          <div class="contract-title">{{ $t('personal::open-contract::comboInfo') }}</div>
          <z-table :data="[combo]" :columns="payColumns" :pagination="false" border></z-table>
          <div class="contract-title mt-32 mb-0" @click="unfold = !unfold">
            {{ $t('personal::contract::payInfo') }}
            <i class="el-icon-arrow-down" :class="{ unfold: unfold }"></i>
          </div>
          <el-collapse-transition v-if="combo && combo.payInfo">
            <div class="info-wrap mb-16" v-show="unfold">
              <div class="info-line">
                <span style="color: #666">{{ $t('personal::contract::comboName') }}</span>
                <span>{{ combo.name || combo.comboName }}</span>
              </div>
              <div class="info-line">
                <span style="color: #666">{{ $t('personal::contract::comboPrice') }}</span>
                <span>{{ combo.priceInfo.price }} / {{ filterUnit[combo.priceInfo.cycleUnit] }}</span>
              </div>
              <div class="info-line">
                <span style="color: #666">{{ $t('personal::contract::discount') }}</span>
                <span style="color: #ff0022" v-if="combo.payInfo.rentalDiscountAmount > 0">
                  {{ discountType }} ${{ combo.payInfo.rentalDiscountAmount }}
                </span>
                <span v-else>0</span>
              </div>
              <div class="info-line">
                <span class="bold-font">{{ $t('personal::contract::amount') }}</span>
                <span v-if="typeof combo.payInfo.firstPayAmount == 'number' && combo.priceInfo.cycleUnit !== 'y'">
                  <p class="bold-font">
                    {{ $t('personal::contract::firstPayAmount', { type: filterUnit[combo.priceInfo.cycleUnit] }) }}
                    ${{ combo.payInfo.firstPayAmount }}
                  </p>
                  <p class="mt-16" v-if="typeof combo.payInfo.nextPayAmount == 'number'">
                    {{ $t('personal::contract::nextPayAmount', { type: filterUnit[combo.priceInfo.cycleUnit] }) }}
                    ${{ combo.payInfo.nextPayAmount }} / {{ filterUnit[combo.priceInfo.cycleUnit] }}
                  </p>
                </span>
                <span class="bold-font" v-else>
                  {{ combo.payInfo.firstPayAmount || combo.priceInfo.price }} /
                  {{ filterUnit[combo.priceInfo.cycleUnit] }}
                </span>
              </div>
            </div>
          </el-collapse-transition>
          <div class="contract-title mt-32">{{ $t('personal::open-contract::selectPayCard') }}</div>
          <div class="card-list mb-16">
            <div
              class="card-item"
              :class="{ choose: item.id === selectCard.id }"
              @click="chooseCard(item)"
              v-for="item in cards"
              :key="item.id"
            >
              <img style="height: 20px" :src="filterImg(item.cardBrand)" />
              <span>************* {{ item.cardNum }}</span>
            </div>
            <div class="card-item add-card" @click="active = 1">
              <i class="iconfont iconadd"></i>
              {{ $t('personal::open-contract::addOtherCard') }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="closeDialog">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button type="primary" @click.stop="submit" :loading="loading">
          {{ $t('system::common::btn::confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 支付结果 -->
    <el-dialog :visible.sync="payVisible" width="440px" custom-class="result" :show-close="false">
      <div class="result-wrap">
        <i class="el-icon-close" @click="payVisible = false" v-if="result"></i>
        <div class="loading-wrap" v-loading="payLoading" v-if="!result"></div>
        <i class="el-icon-success" v-if="result === 1"></i>
        <i class="el-icon-error" v-if="result === 2"></i>
        <p class="result-title">{{ resultTitle }}</p>
        <p class="result-tips">{{ resultTips }}</p>
        <el-button v-if="result === 1" @click="toMyContract" class="mt-32" type="primary" size="small">
          {{ $t('personal::open-contract::orderDetail') }}
        </el-button>
        <el-button v-if="result === 2" @click="payAgain" class="mt-32" type="primary" size="small">
          {{ $t('personal::open-contract::payAgain') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import {
  getCardsList,
  getBindContract,
  bindCompelete,
  postPayment,
  addContract,
  checkCouponCode,
  checkPayDetail,
  bindCardFail,
} from '@/server/personal/contract'
import { payColumns, filterUnit, discountTypeMap, filterImg } from '../config'
export default {
  data() {
    return {
      payColumns,
      filterUnit,
      discountTypeMap,
      visible: false,
      stripe: null,
      loading: false,
      count: 0,
      timer: null,
      cardNumber: null,
      cardDate: null,
      cardCvc: null,
      isCheck: false,
      active: 0,
      cards: [],
      steps: [this.$t('personal::open-contract::bindCard'), '优惠码确认', this.$t('personal::open-contract::payCard')],
      selectCard: null,
      payLoading: false,
      payVisible: false,
      resultTitle: this.$t('personal::open-contract::paying'),
      resultTips: this.$t('personal::open-contract::notClose'),
      result: '', // 1：成功，2：失败
      couponCode: '',
      unfold: false,
      payment: {}, // 支付参数
      resultMsg: '', // 错误信息，为1时验证用过，2套餐不匹配
      combo: '',
      tempCombo: '',
      getLoading: false,
    }
  },
  props: {
    value: {},
    selectCombo: {
      default: () => {},
    },
    selectPayment: {
      default: () => {},
    },
    payCouponEnable: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    filterImg,
    // 获取绑卡列表
    async getCards() {
      this.getLoading = true
      const { data } = await getCardsList()
      this.getLoading = false
      if (data.code === this.$code) {
        this.cards = data.data || []
        if (data.data.length > 0) {
          this.selectCard = data.data.find(item => item.defaulted)
          if (this.payment.subscriptionNo) {
            this.active = 3
            this.checkPayDetail()
          } else {
            this.active = 2
          }
        } else {
          this.active = 1
        }
      }
    },
    chooseCard(item) {
      this.selectCard = item
    },
    toPdf() {
      window.open('/xieyi.pdf', '_blank')
    },
    // 初始化stripe
    init() {
      this.$nextTick(() => {
        console.log(process.env.VUE_APP_ENV)
        this.stripe = Stripe(
          ['dev', 'test'].includes(process.env.VUE_APP_ENV)
            ? 'pk_test_51IuWg9KnDWrNQiNS8LVTrmRWEBLRPhCyDWCGKiEvnTMbaFlPvTt0su48IAbj71801S0P42foXRo0Bqg7j97g2P6D00rPsMWsvW'
            : // ? 'pk_live_51HjEn8L5IRjRW9FDWXJgDAjtf9rsfUYMy1T5xiu1yEZPYroyF0HDIjwE7WT9cHLZk72E0XvwORjacduPqf07dnOF00siAs0T7h'
            process.env.VUE_APP_ENV === 'uat'
            ? // ? 'pk_live_51IuWg9KnDWrNQiNSQQnG6kRO2SM8Gi7AONgPzRMQw93TOBbrnifgjL0YQd4driZcYr4KG64cqlSlNMrFZ2iNkwsQ00ezywhBzd'
              'pk_live_51HjEn8L5IRjRW9FDWXJgDAjtf9rsfUYMy1T5xiu1yEZPYroyF0HDIjwE7WT9cHLZk72E0XvwORjacduPqf07dnOF00siAs0T7h'
            : 'pk_live_51JeIKQHIljMoNvzLuOA7KAYvYNaPA5DC8SFahpsFqzWflzzGQKRhXEEI6crWYSA763YnH1S2DLP6iyWMKE8pNy3N00ZZEzSz3U'
        )
        let elements = this.stripe.elements({ locale: Cookies.get('language') == 'en' ? 'en' : 'zh' })
        var style = {
          iconStyle: 'solid',
          base: {
            color: '#010517',
            fontSize: '14px',
            '::placeholder': {
              color: '#999999',
            },
          },
          invalid: {
            color: '#ff0022',
            iconColor: '#fa755a',
          },
        }
        this.cardNumber = elements.create('cardNumber', {
          style: style,
          placeholder: this.$t('personal::open-contract::请输入卡号'),
        })
        this.cardNumber.mount('#card-number')
        this.cardDate = elements.create('cardExpiry', {
          style: style,
          placeholder: this.$t('personal::open-contract::有效期(MM/YY)'),
        })
        this.cardDate.mount('#card-date')
        this.cardCvc = elements.create('cardCvc', {
          style: style,
          placeholder: this.$t('personal::open-contract::卡安全码'),
        })
        this.cardCvc.mount('#card-cvc')
        const cards = ['cardNumber', 'cardDate', 'cardCvc']
        cards.forEach(item => {
          this[item].on('change', event => {
            let displayError = document.getElementById(`${item}-errors`)
            if (event.error) {
              displayError.textContent = event.error.message
            } else {
              displayError.textContent = ''
            }
          })
        })
      })
    },
    closeDialog() {
      let error = ''
      try {
        document.querySelectorAll('.error-wrap').forEach(item => {
          error += item.innerText
        })
      } catch (err) {}
      this.$store.dispatch('buried', {
        event: 'Personal center click',
        packageId: this.combo.id,
        packagePaymentMethod: this.combo.priceInfo.cycleUnit,
        steps: this.active,
        failureReminder: error,
      })
      this.visible = false
    },
    async submit() {
      if (this.active === 1) {
        await this.firstStep()
      } else if (this.active === 2) {
        await this.secondStep()
      } else {
        await this.thirdStep()
      }
      let error = ''
      try {
        document.querySelectorAll('.error-wrap').forEach(item => {
          error += item.innerText
        })
      } catch (err) {}
      this.$store.dispatch('buried', {
        event: 'Personal center click',
        packageId: this.combo.id,
        packagePaymentMethod: this.combo.priceInfo.cycleUnit,
        steps: this.active,
        failureReminder: error,
      })
    },
    async firstStep() {
      if (!this.isCheck) return this.$message.warning(this.$t('personal::contract::agreement-tips'))
      // 目前没用到token
      // this.stripe.createToken(this.cardNumber).then(res => {
      //   console.log(res)
      //   if (res.token) {
      this.loading = true
      // 获取绑卡密钥
      const { data } = await getBindContract()
      if (data.code === this.$code) {
        const clientSecret = data.data.clientSecret // 绑卡密钥
        // const clientSecret = 'seti_1Jk1Y9L5IRjRW9FDnGXIODrH_secret_KOpCtT74iknXGpu3CKcqgKlvdRpqCQP' // 绑卡密钥
        await this.stripe
          .confirmCardSetup(clientSecret, {
            payment_method: {
              card: this.cardNumber,
              billing_details: {
                name: this.$store.state.user.userName,
              },
            },
          })
          .then(async result => {
            console.log(result)
            if (result.error) {
              // this.$message.warning(this.$t('personal::contract::pay_error_tips'))
              // 收集绑卡失败信息
              this.$message.warning(result.error.message)
              await bindCardFail({
                cardBrand:
                  (result.error.payment_method &&
                    result.error.payment_method.card &&
                    result.error.payment_method.card.brand) ||
                  '',
                cardNum:
                  (result.error.payment_method &&
                    result.error.payment_method.card &&
                    result.error.payment_method.card.last4) ||
                  '',
                failReason: result.error.message,
                platform: 1,
              })
            } else {
              const status = await this.checkCard()
              if (status) {
                this.$message.success(this.$t('personal::contract::绑卡成功'))
                this.getCards()
              }
            }
          })
      }
      this.loading = false
      //   }
      // })
    },
    async secondStep() {
      this.loading = true
      // 确认订单，生成待支付订单
      const { data } = await addContract({
        priceId: this.combo.priceInfo.id,
        platform: 1,
        couponCode: this.couponCode,
        type: 0,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.payment = data.data
        this.checkPayDetail()
        this.active = 3
      }
    },
    async thirdStep() {
      this.resule = ''
      this.payLoading = true
      this.visible = false
      this.payVisible = true
      const { data } = await postPayment({
        subscriptionNo: this.payment.subscriptionNo,
        platform: 1,
        payMethod: this.selectCard.id,
      })
      this.payLoading = false
      if (data.code === this.$code) {
        this.resultTitle = this.$t('personal::contract::支付成功')
        this.resultTips = this.$t('personal::contract::paySuccess')
        this.result = 1
        this.$emit('success')
        this.timer = setInterval(async () => {
          if ((this.user.combo.isExpire || this.user.combo.isTrial) && this.count < 12) {
            this.count += 1
            await this.$store.dispatch('getCombo', 6)
          } else {
            clearInterval(this.timer)
          }
        }, 5000)
      } else {
        this.resultTitle = this.$t('personal::contract::支付失败')
        this.resultTips = this.$t('personal::contract::payFail')
        this.result = 2
      }
    },
    // 刷新绑卡状态，服务拉stripe绑卡信息
    async checkCard() {
      const { data } = await bindCompelete()
      if (data.code === this.$code) {
        return !!data.data
      }
    },
    payAgain() {
      this.active = 3
      this.result = ''
      this.resultTitle = this.$t('personal::open-contract::paying')
      this.resultTips = this.$t('personal::open-contract::notClose')
      this.payVisible = false
      this.visible = true
    },
    toMyContract() {
      this.$router.push('/my-contract?tab=1')
      this.payVisible = false
    },
    // 初始化初始值
    closed() {
      this.isCheck = false
      this.couponCode = ''
      this.resultMsg = ''
      this.tempCombo = ''
      this.payment = {}
      this.unfold = false
      this.result = ''
      this.resultTitle = this.$t('personal::open-contract::paying')
      this.resultTips = this.$t('personal::open-contract::notClose')
    },
    // 失焦检查优惠券码
    async checkCode() {
      if (!this.couponCode) return
      const { data } = await checkCouponCode({
        code: this.couponCode,
        priceId: this.combo.priceInfo.id,
      })
      if (data.code === this.$code) {
        if (data.data.valid) {
          this.resultMsg = 1 // 错误信息，为1时验证优惠券已使用，2套餐不匹配
        } else {
          this.resultMsg = 2
          this.tempCombo = data.data.matchedCombo
        }
      } else {
        this.resultMsg = data.msg
      }
    },
    // 使用优惠券码匹配的套餐
    changeCombo() {
      this.combo = this.tempCombo
      this.checkCode()
    },
    // 获取支付信息
    async checkPayDetail() {
      const { data } = await checkPayDetail(this.payment.subscriptionNo)
      if (data.code === this.$code) {
        this.combo = {
          ...this.combo,
          payInfo: {
            ...data.data,
          },
        }
      }
    },
  },
  computed: {
    ...mapState(['user']),
    discountType() {
      if (this.combo && this.combo.payInfo && this.combo.payInfo.paymentType === 'y') {
        return this.$t('personal::contract::yearPay')
      } else {
        if (this.combo && this.combo.payInfo && this.combo.payInfo.discountType === 0) {
          return this.$t('personal::contract::everyMonth', { type: this.filterUnit[this.combo.payInfo.paymentType] })
        } else {
          return this.$t('personal::contract::firstMonth', { type: this.filterUnit[this.combo.payInfo.paymentType] })
        }
      }
    },
  },
  watch: {
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.init()
        this.getCards()
      }
    },
    value(val) {
      this.visible = val
    },
    selectCombo: {
      handler(val) {
        this.combo = val
      },
      deep: true,
    },
    selectPayment: {
      handler(val) {
        this.payment = val
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-step.is-center .el-step__description,
.el-step__description.is-finish {
  color: #999999;
}
/deep/.el-dialog.result .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
/deep/.error-border .el-input__inner {
  border: 1px solid #ff0022;
}
/deep/.success-border .el-input__inner {
  border: 1px solid #0560fd;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #010517;
}
/deep/.el-table .cell {
  color: #666;
}
.result-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .loading-wrap {
    width: 40px;
    height: 40px;
  }
  .result-title {
    font-size: 16px;
    font-weight: bold;
    margin: 16px 0;
  }
  .result-tips {
    font-size: 14px;
    color: #666666;
  }
  .el-icon-close {
    font-size: 12px;
    color: #999999;
    position: absolute;
    right: -3px;
    top: -10px;
    font-weight: bold;
    cursor: pointer;
  }
  .el-icon-success {
    font-size: 40px;
    color: #0560fd;
  }
  .el-icon-error {
    font-size: 40px;
    color: rgb(223, 84, 38);
  }
}
.step-container {
  padding: 14px 24px;
  background: #fbfbfb;
  border-radius: 4px;
  margin-bottom: 24px;
}
.pay-tips {
  font-size: 14px;
  text-align: left;
  margin-top: 16px;
  &__desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 11px;
    line-height: 18px;
  }
}
.card-title {
  margin: 0 0 16px;
  span {
    color: #ff0022;
    margin-right: 5px;
  }
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card-item {
    width: 43%;
    padding: 18px 14px;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #010517;
    margin-bottom: 16px;
    &.choose {
      border: 1px solid #0560fd;
    }
    &.add-card {
      color: #0560fd;
      .iconadd {
        font-size: 17px;
        color: #0560fd;
        margin-right: 10px;
      }
    }
  }
}
.contract-title {
  font-size: 14px;
  font-weight: bold;
  color: #010517;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-icon-arrow-down {
    font-size: 18px;
    font-weight: bold;
    color: #999;
    transition: 0.3s;
    &.unfold {
      transform: rotate(180deg);
    }
  }
}
.info-line {
  padding: 16px 0;
  border-bottom: 1px solid #eeeeee;
  color: #666666;
  display: flex;
  justify-content: space-between;
  .bold-font {
    font-weight: bold;
    color: #ff0022;
  }
}
.error-tips {
  color: #ff0022;
  margin-top: 10px;
  font-size: 12px;
}
.error-wrap {
  color: #ff0022;
  margin-bottom: 12px;
}
.StripeElement {
  box-sizing: border-box;
  height: 45px;
  padding: 12px 14px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  background-color: white;
}
.StripeElement--focus {
  box-shadow: 0 1px 5px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #ff0022;
}
.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
